import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "jz-input-tip"
};
import { ref, onMounted } from "vue";
import { CircleCloseFilled } from "@element-plus/icons-vue";
export default {
  __name: 'Input',
  props: {
    type: String,
    title: String,
    value: String,
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    blur: {
      type: Boolean,
      default: true
    },
    focus: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const props = __props;
    const inpShow = ref(false);
    const inpText = ref("");
    const inpValue = ref();

    // const _blur =()=>{}
    const _blur = () => {
      if (!props.blur) return;
      switch (props.type) {
        case "info":
          infoBlur();
          break;
        default:
          break;
      }
    };
    const infoBlur = () => {
      // inpText.value = "手机号 / 邮箱不能为空";
      if (inpValue.value) {
        // 手机号正则（11位数字，1开头）
        const PHONE_REGEX = /^1[3-9]\d{9}$/;
        // 邮箱正则（简化版）
        const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (PHONE_REGEX.test(inpValue.value)) {
          inpShow.value = false;
          //   formState.identity_type = "phone";
          return true;
        } else if (EMAIL_REGEX.test(inpValue.value)) {
          inpShow.value = false;
          //   formState.identity_type = "email";
          return true;
        } else {
          inpShow.value = true;
          inpText.value = "手机号格式 / 邮箱格式不正确";
        }
      }
      //   inpShow.value = true;
      return false;
    };
    const _focus = () => {
      if (!props.focus) return;
      inpShow.value = false;
    };
    onMounted(() => {
      inpValue.value = props.value;
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("p", {
        class: "jz-input-title",
        style: _normalizeStyle({
          color: inpShow.value ? '#d32029' : '#000000'
        })
      }, _toDisplayString(__props.title), 5), _createVNode(_component_el_input, {
        class: "mt10 height40",
        modelValue: inpValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => inpValue.value = $event),
        placeholder: '请输入' + __props.title,
        readonly: __props.readonly,
        disabled: __props.disabled,
        onBlur: _blur,
        onFocus: _focus
      }, null, 8, ["modelValue", "placeholder", "readonly", "disabled"]), inpShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(CircleCloseFilled))]),
        _: 1
      }), _cache[1] || (_cache[1] = _createTextVNode()), _createElementVNode("span", null, _toDisplayString(inpText.value), 1)])) : _createCommentVNode("", true)], 64);
    };
  }
};